import React from 'react';
import { ExcelDownloadContext } from 'contexts/ExcelDownloadContext';

const useExcelDownload = () => React.useContext(ExcelDownloadContext);
export default useExcelDownload;
